import React, { Component } from 'react';

export default class Google_pass extends Component {
	render() {
		return <div style={{}}>
			
			<img src={require('./img/googleLogo.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				height:32,
				width:"auto",
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
				fontSize:16,
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Welcome</span>
				<br/>
				<br/>
				<img src={require("./img/name.png")} style={{
					width:15,
					marginTop:10	
				}}/>
				<span style={{
					marginLeft:15,
					// color:"white"
					// fontWeight:"bold"	
					fontSize:16
				}}>example@gmail.com</span>
				
				<div style={{
					position:"absolute",
					top:108,
					width: 300,
					height: 48,
					
				}}>
				<span style={{
					color:global.blue,	
					fontSize:14	
				}}>Enter your password</span>
				<br/>
				<span style={{					
					fontSize:16,		
					position:"absolute",
					top: 24,
				}} > •••••••• </span>
				<div style={{
					width: "100%",
					height:1,
					position:"absolute",
					bottom:0,
					backgroundColor:"grey",
					opacity:0.3
				}}/>	
					<br/>	
					<br/>	
					<br/>	
					<img src={require('../Comp/img/df.png')} style={{
						// width: 644/2.2,
						// height: 148/2.2
						marginLeft:-10
					}}/>
				</div>
			</div>
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Google_pass.js